export const oriasQueryKeys = {
  all: ["orias"] as const,
  details: () => [...oriasQueryKeys.all, "detail"] as const,
  detail: (siren: string) => [...oriasQueryKeys.details(), siren] as const,
  lists: () => [...oriasQueryKeys.all, "list"] as const,
  list: (sirens: string[]) => [...oriasQueryKeys.lists(), sirens] as const,
};
